"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AckoMainTheme = void 0;
const border_1 = __importDefault(require("./border"));
const typography_1 = __importDefault(require("./typography"));
const breakpoints_1 = __importDefault(require("./breakpoints"));
const spacing_1 = __importDefault(require("./spacing"));
const colors_1 = __importDefault(require("./colors"));
exports.AckoMainTheme = {
    defaultMode: 'light',
    border: border_1.default,
    breakpoints: breakpoints_1.default,
    colors: colors_1.default,
    spacing: spacing_1.default,
    typography: typography_1.default
};
exports.default = exports.AckoMainTheme;
//# sourceMappingURL=index.js.map